import { render, staticRenderFns } from "./TBK_call_request.vue?vue&type=template&id=476defe4&"
import script from "./TBK_call_request.vue?vue&type=script&lang=js&"
export * from "./TBK_call_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports